import { render, staticRenderFns } from "./NameListGrudate.vue?vue&type=template&id=8e7d1542&"
import script from "./NameListGrudate.vue?vue&type=script&lang=js&"
export * from "./NameListGrudate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports